module.exports = __webpack_public_path__ + "img/706-5d41da.png";